import {OnDestroy} from '@angular/core';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {AdminService} from './admin.service';
import {isStandardVersionConflict, savedStandardVersion, StandardVersionSnapshot} from './standard-version';
import {StandardFamiliarizationUser} from '../models/standard-user.model';
import {StepConfirmPopupComponent} from '../content-page/admin/create-operating-standard/step-confirm-popup/step-confirm-popup.component';

const REMOVAL_CONFIRMATION = 'CONFIRM_REMOVE';
const REMOVAL_ACCEPTED = 'ok';
const NAME_SEPARATOR = ' ';
const NO_REMOVAL_ERROR = '';
const HTTP_OK = 200;
const REMOVAL_ERROR = {conflict: 'STANDARD_VERSION_CONFLICT_MESSAGE', failed: 'STANDARD_ASSIGNMENT_SAVE_FAILED'};

interface StandardUserRemovalRequest {
  source: StandardVersionSnapshot;
  snapshot: StandardVersionSnapshot;
  userId: string;
  originalVersion: number;
  accept: (users: StandardFamiliarizationUser[]) => void;
}

export class StandardUserRemoval implements OnDestroy {
  pending = false;
  requiresReload = false;
  errorKey = NO_REMOVAL_ERROR;
  private destroyed = false;
  private cancelled$ = new Subject<void>();

  constructor(private adminService: AdminService, private modalService: NgbModal) {}

  remove(source: StandardVersionSnapshot, entry: StandardFamiliarizationUser,
         accept: (users: StandardFamiliarizationUser[]) => void): void {
    if (this.pending || this.requiresReload || this.destroyed || !source || !entry || !entry.user) { return; }
    const request = {source: source, snapshot: Object.assign({}, source), userId: entry.user.id,
      originalVersion: source.version, accept: accept};
    this.pending = true;
    this.errorKey = NO_REMOVAL_ERROR;
    const modal = this.modalService.open(StepConfirmPopupComponent);
    modal.componentInstance.massage = REMOVAL_CONFIRMATION;
    modal.componentInstance.paramOne = entry.user.firstName + NAME_SEPARATOR + entry.user.lastName;
    modal.result.then(result => {
      if (this.destroyed) { return; }
      if (result === REMOVAL_ACCEPTED) { this.send(request); }
      else { this.pending = false; }
    }, () => { this.pending = false; });
  }

  reset(): void {
    this.cancelled$.next();
    this.pending = this.requiresReload = false;
    this.errorKey = NO_REMOVAL_ERROR;
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.cancelled$.next();
    this.cancelled$.complete();
  }

  private send(request: StandardUserRemovalRequest): void {
    this.adminService.deleteUserFromStandard(request.snapshot, request.userId).takeUntil(this.cancelled$).subscribe(
      response => this.acceptResponse(request, response), error => this.rejectResponse(error)
    );
  }

  private acceptResponse(request: StandardUserRemovalRequest, response: HttpResponse<StandardFamiliarizationUser[]>): void {
    this.pending = false;
    if (response.status !== HTTP_OK || !Array.isArray(response.body)) {
      this.requiresReload = true; this.errorKey = REMOVAL_ERROR.failed; return;
    }
    const version = savedStandardVersion(response);
    if (request.source.version === request.originalVersion && version != null) { request.source.version = version; }
    else {
      this.requiresReload = true;
      this.errorKey = version == null ? REMOVAL_ERROR.failed : REMOVAL_ERROR.conflict;
    }
    request.accept(response.body);
  }

  private rejectResponse(error: HttpErrorResponse): void {
    this.pending = false;
    this.requiresReload = true;
    this.errorKey = isStandardVersionConflict(error) ? REMOVAL_ERROR.conflict : REMOVAL_ERROR.failed;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/standard-user-removal.ts